import { WarningOutlined, FileTextOutlined } from '@ant-design/icons';
import StatsCard from 'components/new-ui/base/stats-card/StatsCard';
import ShipmentIcon from 'components/icons/ShipmentIcon';
import WeightIconOutlined from 'components/icons/WeightIconOutlined';
import { StatisticsProps } from 'types/common';

type Props = StatisticsProps & {};

const StatsCards = ({ data, error, loading, refetch }: Props) => {
    const jobsCount = data?.jobsStatistic.totalJobs;
    const activeJobs = data?.jobsStatistic.activeJobs;
    const declarations = data?.declarationsStatistic.totalDeclarations;
    const actionRequiredDeclarations = data?.declarationsStatistic.actionRequiredDeclarations;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 24,
            }}
        >
            <StatsCard
                label="Jobs"
                type="default"
                icon={<ShipmentIcon style={{ color: 'var(--blue-6)' }} />}
                count={jobsCount}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Active Jobs"
                type="success"
                icon={<WeightIconOutlined style={{ color: 'var(--polar-green-6)' }} />}
                count={activeJobs}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Declarations"
                type="warning"
                icon={<FileTextOutlined style={{ color: 'var(--orange-6)' }} />}
                count={declarations}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />

            <StatsCard
                label="Attention Required"
                type="error"
                icon={<WarningOutlined style={{ color: 'var(--dust-red-7)' }} />}
                count={actionRequiredDeclarations}
                loading={loading}
                error={Boolean(error)}
                onRefresh={refetch}
            />
        </div>
    );
};

export default StatsCards;
